import {NavigationComponent} from "../components/public/navigation.component";
import {useEffect, useState} from "react";
import axios from "axios";

export const NewsPage = () => {

 

  return (
      <>
        <div className={"tesapp-tesapp"}>
            <div className={"tesapp-component"}>
                <div className={"tesapp-component"}>
                    <div className={"tesapp-navigation"}>
                        <div className={"tesapp-navigation-branding"}><a href={"/"}>
                            <img src={"/logo-temnography.png"} alt={"Logo Temnography®"} width={100}
                                 className={"tesapp-branding-logo"}/></a>
                        </div>
                        <div className={"tesapp-navigation-elementor"}>
                            <ul className={"tesapp-el-builder"}>
                                <li><a href={"/news"}><b>Aktualności</b></a></li>
                                <li><a href={"/#jak-to-dziala"}>Jak to działa?</a></li>
                                <li><a href={"/#zalety"}>Zalety z korzystania</a></li>
                                <li><a href={"/#wersje-produktu"}>Wersje produktu</a></li>
                                <li><a href={"/#dystrybutor"}>Dystrybucja</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className={"tesapp-present"}>
                        <div className={"tesapp-present-content"}>
                            <h1 className={"tesapp-f-title"}>AKTUALNOŚCI</h1>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-banner"}>
                    <div className={"tesapp-line-space"}/>
                </div>
                <div className={"tesapp-container"}
                     style={{marginTop: "-50px", display: "block", paddingTop: 0}}>
                    <div className={"tesapp-container-content"} id={"jak-to-dziala"}>
                        <h1>Najnowsze artykuły</h1>

                                <div className="tesapp-article tesapp-c-component" style={{display: "flex", alignItems: "start", justifyContent: "space-between", gap: "100px", marginBottom: "10px"}}>
                                    <div>
                                        <h2 className="tesapp-title-black">TES HT100 technologia Temnografii potwierdzona badaniami klinicznymi</h2>
                                        <p>Przeczytaj więcej o prowadzonych badaniach!</p>
                                    </div>
                                    <div style={{width: "auto"}}>

                                        <a href={`/news/article/1`} style={{display: "block", whiteSpace: "pre"}}

                                           className="tesapp-btn btn-desktop">
                                            Czytaj więcej
                                        </a>
                                    </div>
                                </div>

                                  <div className="tesapp-article tesapp-c-component" style={{display: "flex", alignItems: "start", justifyContent: "space-between", gap: "100px", marginBottom: "10px"}}>
                                    <div>
                                        <h2 className="tesapp-title-black">Testy TEMNOGRAFU w Górnoślaskim Centrum Medycznym im. prof. Leszka Gieca.</h2>
                                        <p>Zobacz wpis na LINKEDIN!</p>
                                    </div>
                                    <div style={{width: "auto"}}>

                                        <a href={`https://pl.linkedin.com/posts/g-rno-l-skie-centrum-medyczne-im-prof-leszka-gieca-l-skiego-uniwersytetu-medycznego-w-katowicach_temnograf-temnograf-activity-7504156878680051713-rbcW`} style={{display: "block", whiteSpace: "pre"}}

                                           className="tesapp-btn btn-desktop">
                                            Otwórz LinkedIn
                                        </a>
                                    </div>
                                </div>

   <div className="tesapp-article tesapp-c-component" style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "10px" }}>
  
  {/* Górna sekcja (nagłówek i przycisk - bez zmian, tylko zamknięte w flexie kolumnowym) */}
  <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: "100px", width: "100%" }}>
    <div>
      <h2 className="tesapp-title-black">Braliśmy udział w targach WARSAW MEDICAL EXPO</h2>
      <p>Przeczytaj wpis z tego wydarzenia.</p>
    </div>
    <div style={{ width: "auto" }}>
      <a 
        href="https://warsawmedicalexpo.com/z-przyjemnoscia-zapraszamy-na-prelekcje-medical-service/" 
        style={{ display: "block", whiteSpace: "pre" }}
        className="tesapp-btn btn-desktop"
      >
        Otwórz stronę TARGÓW
      </a>
    </div>
  </div>

  {/* Dolna sekcja: Galeria 10 zdjęć */}
  <div className="tesapp-photo-grid">
    {/* Przykład z tablicą 10 elementów (możesz podmienić na własne ścieżki do zdjęć) */}
    {[...Array(10)].map((_, index) => (
      <div key={index} className="tesapp-photo-item">
        <img 
          src={`./w${index + 1}.jpeg`} 
          alt={`Warsaw Medical Expo ${index + 1}`} 
        />
      </div>
    ))}
  </div>
</div>

</div>
                </div>
                <div className={"tesapp-footer-2 tesapp-c-component"} id="dystrybutor">
                    <h1 className={"tesapp-title-black"}>Dystrybutor</h1>
                    <div className={"tesapp-footer-body"}>
                        <div className={"tesapp-distributor-container"}>
                            <img src={"logo.png"} className={"tesapp-cmp-icon"} width={160} height={50}/>
                            <div className={"tesapp-cmp-present"}>
                                <div className={"tesapp-distributor-info"}>
                                    <div><b>Medical Service Sp. z o. o.</b></div>
                                    <div>ul. Jordana 25</div>
                                    <div>40-952 Katowice</div>
                                </div>
                            </div>
                            <div className={"tesapp-cmp-more-info"}>
                                <div>NIP: 9542468164</div>
                                <div>Tel./Fax 257 84 40 | <b>+48 605405477</b></div>
                                <div>Mail: ms@medical-service.pl</div>
                            </div>
                        </div>
                        <div className={"footer-body-action"}>
                            <a href={"//medical-service.pl"} target={"_blank"} className={"tesapp-btn"}>Otwórz stronę
                                internetową</a>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-footer"}>
                    <div className={"tesapp-footer-col-left"}>
                        <div className={"tesapp-distributor"}>
                            <div className={"tesapp-text-upper-white-mdk384"}>&copy; 2024 Wszelkie prawa zastrzeżone
                            </div>
                        </div>
                    </div>
                    <div className={"tesapp-footer-col-right"}>
                        Stworzono przez <b><a href={"//proevent-solutions.pl/"} style={{color: "white", textDecoration: "none"}}
                                         target={"_blank"}>PROEVENT SOLUTIONS Sp. z o. o.</a></b>
                    </div>
                </div>
            </div>

        </div>
      </>
  )
}